import React from 'react';
import "./styles.css";

const RouteButton = ({ isChecked, label, disabled, onSelectionChange }) => {
  return (
      <div onClick={disabled? null: () => onSelectionChange(label, !isChecked)}>
          <button
           className={isChecked ? 'selectedRouteButton' : 'routeButton'}
           disabled={disabled}
           >
            {label}
         </button>
      </div>
  )
}

export default RouteButton